module.exports = __webpack_public_path__ + "static/2-ce9dce43945e8f65591d1bafac748298.png";